module.exports = __webpack_public_path__ + "img/video-loding.bfe38ea0.gif";